__webpack_require__.p = "/hover-squares-game/";